import { FC } from 'react'
import { useRouter } from 'next/router'
import styled from '@emotion/styled'
import Image from 'next/image'

import { Navigation } from '@/components/Header/styles/Navigation.styles'
import SettingsControl from './SettingsControl'

const LogoContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: start;
`

const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 0.25rem;
`

const NavPanel: FC = () => {
    const { push } = useRouter()

    return (
        <Navigation>
            <LogoContainer
                onClick={() => {
                    push('/')
                }}
            >
                <Image
                    src="/images/easywallet/logo-easywallet.png"
                    alt="easywallet logo"
                    width={160}
                    height={32}
                />
            </LogoContainer>

            <ButtonContainer className="button-container">
                <SettingsControl />
            </ButtonContainer>
        </Navigation>
    )
}

export default NavPanel
